<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">TDocSS</span>
      </v-card-title>
      <v-card-actions style="display: flex; width: 100%">
        <div>
          <v-btn v-permit.TDOC_SEARCH @click="search()" class="btn-search">{{
            $t('app.buttons.search')
          }}</v-btn>
          <v-btn v-permit.TDOC_SORT @click="openSortSettings()"
            >ソート設定</v-btn
          >
          <v-btn v-permit.TDOC_NEW @click="goToNew()">受付入力</v-btn>
          <v-btn
            v-permit.TDOC_EDIT
            :disabled="selected.length !== 1"
            @click="goToEdit()"
            >編集</v-btn
          >
          <v-btn
            v-permit.TDOC_REMOVE
            :disabled="selected.length === 0"
            @click="removeBL()"
            >削除</v-btn
          >
          <v-btn
            v-permit.TDOC_SEND_MAIL
            :disabled="selected.length !== 1"
            @click="sendMail()"
            >送信</v-btn
          >
          <v-btn
            v-permit.TDOC_INVOICE_PDF
            :disabled="selected.length !== 1"
            @click="addInvoicePdf()"
            >INVOICE PDF UPLOAD</v-btn
          >
          <v-btn
            v-permit.TDOC_BL_PDF
            @click="openAwbPdfDialog()"
            :disabled="selected.length !== 1"
            >BL PDF UPLOAD</v-btn
          >
          <v-btn
            v-permit.TDOC_MAIL_HISTORY
            :disabled="selected.length !== 1"
            @click="mailHistory()"
            >送信履歴</v-btn
          >
          <v-btn
            v-permit.TDOC_PRINT_PDF
            :disabled="selected.length !== 1"
            @click="printPdf()"
            >袋印刷</v-btn
          >
          <v-btn v-permit.TDOC_DOWNLOAD_EXCEL @click="downloadExcel()"
            >EXCEL 出力</v-btn
          >
          <v-btn
            v-permit.TDOC_DOWNLOAD_FAILED_EXCEL
            style="margin:10px;"
            @click="downloadFailedExcel()"
            >送信失敗履歴Excel出力</v-btn
          >
        </div>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-select
                :items="[
                  { text: '仲介出', value: '仲介出' },
                  { text: '日本出', value: '日本出' },
                ]"
                clearable
                item-text="text"
                item-value="value"
                label="仲介日本出区分"
                v-model="query.placerWay"
              ></v-select>
              <v-text-field label="S/I No" clearable v-model="query.siNo" />
              <remote-autocomplete
                label="生産拠点"
                url="expense-codes/code/kv"
                v-model="query.shipperCode"
              />
              <remote-autocomplete
                label="船積担当者"
                url="employees/tdoc-kv"
                v-model="query.orderPlacerCode"
              />
              <remote-autocomplete
                label="積出港"
                url="ports/kv?tradeType=EXPORT"
                v-model="query.originPortCode"
              />
              <v-select
                :items="$store.state.shippingModes"
                clearable
                item-text="text"
                item-value="value"
                label="輸送区分"
                v-model="query.shippingMode"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-text-field label="B/L No" clearable v-model="query.blNo" />
              <v-text-field
                label="SEC Ref.No"
                clearable
                v-model="query.refNo"
              />
              <remote-autocomplete
                label="バイヤー"
                url="buyers/code/kv"
                v-model="query.consigneeCode"
              />
              <remote-autocomplete
                label="乙仲担当者"
                url="employees/tdoc-kv"
                v-model="query.carrierCode"
              />
              <remote-autocomplete
                label="仕向港"
                url="ports/kv?tradeType=EXPORT"
                v-model="query.dischargePortCode"
              />
              <v-select
                :items="[
                  { text: '送信済み', value: 'true' },
                  { text: '未送信', value: 'false' },
                ]"
                clearable
                item-text="text"
                item-value="value"
                label="メール送信区分"
                v-model="query.sentEmail"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="INV No"
                clearable
                v-model="query.invoiceNo"
              />
              <v-text-field
                label="仕入INV No"
                clearable
                v-model="query.buyerInvNo"
              />
              <v-text-field label="E/D No" clearable v-model="query.edNo" />

              <div class="bl-date-wrap">
                <date-input
                  label="B/L DATE"
                  :max="query.blDateTo"
                  v-model="query.blDateFrom"
                ></date-input>
                <span style="padding: 5px; padding-top: 20px">~</span>
                <date-input
                  :min="query.blDateFrom"
                  v-model="query.blDateTo"
                ></date-input>
              </div>
              <div class="bl-date-wrap">
                <date-input
                  label="書類受付期間"
                  :max="query.documentAcceptTo"
                  v-model="query.siReleaseDateFrom"
                ></date-input>
                <span style="padding: 5px; padding-top: 20px">~</span>
                <date-input
                  :min="query.siReleaseDateFrom"
                  v-model="query.siReleaseDateTo"
                ></date-input>
              </div>
              <v-select
                :items="[
                  { text: '	済', value: true },
                  { text: '否', value: false },
                ]"
                clearable
                item-text="text"
                item-value="value"
                label="袋印刷区分"
                v-model="query.bagPrinted"
              ></v-select>
            </v-flex>
            <v-flex xs3 v-show="isOperator()">
              <label class="options-label">ステータス</label>
              <table class="options">
                <tr>
                  <td></td>
                  <td>指定無し</td>
                  <td>済</td>
                  <td>未</td>
                </tr>
                <tr>
                  <td>船積担当の有無</td>
                  <td>
                    <v-radio-group
                      v-model="query.orderPlacer"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.orderPlacer"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.orderPlacer"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>
                <tr>
                  <td>袋返却日</td>
                  <td>
                    <v-radio-group
                      v-model="query.agentWaybillReturnedDate"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.agentWaybillReturnedDate"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.agentWaybillReturnedDate"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>
                <tr>
                  <td>フレイト確認日</td>
                  <td>
                    <v-radio-group
                      v-model="query.shipmentConfirmDate"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.shipmentConfirmDate"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.shipmentConfirmDate"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>

                <tr>
                  <td>CLP</td>
                  <td>
                    <v-radio-group
                      v-model="query.containerPackingListDate"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.containerPackingListDate"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.containerPackingListDate"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>

                <tr>
                  <td>カスタムＩＮＶ</td>
                  <td>
                    <v-radio-group
                      v-model="query.customInvDate"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.customInvDate"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.customInvDate"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>

                <tr>
                  <td>シッピングインストラクション</td>
                  <td>
                    <v-radio-group
                      v-model="query.dateOfShipment"
                      :mandatory="false"
                    >
                      <v-radio :value="null"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.dateOfShipment"
                      :mandatory="false"
                    >
                      <v-radio :value="true"></v-radio>
                    </v-radio-group>
                  </td>
                  <td>
                    <v-radio-group
                      v-model="query.dateOfShipment"
                      :mandatory="false"
                    >
                      <v-radio :value="false"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.siReleaseDate }}</td>
          <td>
            {{
              getString(props.item.shipperCode) +
                getString(props.item.shipperName, ':')
            }}
          </td>
          <td>
            {{
              getString(props.item.consigneeCode) +
                getString(props.item.consigneeName, ':')
            }}
          </td>
          <td class="over-content">
            <span :title="props.item.blNo">{{ props.item.blNo }}</span>
          </td>
          <td>{{ props.item.blDate }}</td>
          <td class="over-content">
            <span :title="getBuyerInvNo(props.item.buyerInvNo)">{{
              getBuyerInvNo(props.item.buyerInvNo)
            }}</span>
          </td>
          <td class="over-content">
            <span :title="getSiNos(props.item.invoices)">{{
              getSiNos(props.item.invoices)
            }}</span>
          </td>
          <td class="over-content">
            <span :title="getInvNos(props.item.invoices)">{{
              getInvNos(props.item.invoices)
            }}</span>
          </td>
          <td>{{ getShippingMode(props.item.shippingMode) }}</td>
          <td>{{ props.item.originPortCode }}</td>
          <td>{{ props.item.dischargePortCode }}</td>
          <td>{{ props.item.placerWay }}</td>
          <td>{{ props.item.sentEmail === false ? '未送信' : '送信済み' }}</td>
          <td>{{ props.item.bagPrinted ? '済' : '' }}</td>
          <td>
            <v-btn @click="goToDetail(props.item)">B/L詳細</v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <csv-fields @refresh="load" :tdoc="true" ref="csvFields" />
    <add-invoice-pdf-dialog @refresh="load" ref="addInvoicePdfDialog" />
    <v-dialog v-model="show" width="1000">
      <bl-pdf-info
        @close="show = false"
        :isDialog="true"
        :cantEdit="false"
        @refresh="load"
        :bl="chosenBl || {}"
        ref="blPdf"
      ></bl-pdf-info>
    </v-dialog>
    <download-dialog ref="downloadDialog" />
  </v-container>
</template>

<script>
import CsvFields from '@/components/CsvFields'
import addInvoicePdfDialog from './AddInvoicePdfDialog.vue'
import BlPdfInfo from './BlPdfInfo.vue'
import downloadDialog from './DownloadDialog.vue'

export default {
  components: {
    CsvFields,
    addInvoicePdfDialog,
    BlPdfInfo,
    downloadDialog,
  },
  data() {
    return {
      headers: [
        {
          text: '書類受付日',
          value: 'custom.siReleaseDate',
          sortable: false,
        },
        {
          text: '生産拠点',
          value: 'shipper.contactPartnerId',
          sortable: false,
        },
        {
          text: 'バイヤー',
          value: 'consignee.contactPartnerId',
          sortable: false,
        },
        {
          text: 'B/L NO',
          value: 'masterBillNo',
          sortable: false,
        },
        {
          text: 'B/L DATE',
          value: 'masterBillDate',
          sortable: false,
        },
        {
          text: '仕入INV NO',
          value: 'buyerInvNo',
          sortable: false,
        },
        {
          text: 'SINO',
          value: 'siNos',
          sortable: false,
        },
        {
          text: 'INVOICE No',
          value: 'invoiceNos',
          sortable: false,
        },
        {
          text: '輸送区分',
          value: 'shippingModeCode',
          sortable: false,
        },
        {
          text: '積出港',
          value: 'custom.originPortCodeFromTdoc',
          sortable: false,
        },
        {
          text: '仕向港',
          value: 'custom.dischargePortCodeFromTdoc',
          sortable: false,
        },
        {
          text: '仲介日本出区分',
          value: 'custom.placerWay',
          sortable: false,
        },
        {
          text: 'メール送信区分',
          value: 'custom.sentEmail',
          sortable: false,
        },
        {
          text: '袋印刷区分',
          value: 'bagPrinted',
          sortable: false,
        },
        {
          text: '詳細仕分',
          value: 'detail',
          sortable: false,
        },
      ],
      query: {},
      pagination: {
        page: 0,
      },
      selected: [],
      results: [],
      show: false,
      chosenBl: {},
    }
  },
  methods: {
    getQueryResult() {
      var queryResult = []
      queryResult.push({
        fieldName: 'masterBillNo',
        command: 'Eq',
        value: this.query.blNo,
      })
      queryResult.push({
        fieldName: 'custom.originPortCodeFromTdoc',
        command: 'Eq',
        value: this.query.originPortCode,
      })
      queryResult.push({
        fieldName: 'custom.dischargePortCodeFromTdoc',
        command: 'Eq',
        value: this.query.dischargePortCode,
      })
      queryResult.push({
        fieldName: 'custom.placerWay',
        command: 'Eq',
        value: this.query.placerWay,
      })
      queryResult.push({
        fieldName: 'invoices.invNo',
        command: 'Like',
        value: this.query.invoiceNo,
      })

      queryResult.push({
        fieldName: 'invoices.custom.siNo',
        command: 'Like',
        value: this.query.siNo,
      })
      queryResult.push({
        fieldName: 'invoices.custom.secRefNo',
        command: 'Like',
        value: this.query.refNo,
      })
      queryResult.push({
        fieldName: 'custom.buyerInvNo',
        command: 'Like',
        value: this.query.buyerInvNo,
      })

      queryResult.push({
        fieldName: 'custom.carrierEmployee',
        command: 'Eq',
        value: this.query.carrierCode,
      })

      queryResult.push({
        fieldName: 'custom.shipperFromTdoc.contactPartnerId',
        command: 'Eq',
        value: this.query.shipperCode,
      })
      queryResult.push({
        fieldName: 'custom.consigneeFromTdoc.contactPartnerId',
        command: 'Eq',
        value: this.query.consigneeCode,
      })
      queryResult.push({
        fieldName: 'invoices.exportDeclarationNos',
        command: 'Like',
        value: this.query.edNo,
      })
      queryResult.push({
        fieldName: 'custom.siReleaseDate',
        command: 'Gte',
        value: this.query.siReleaseDateFrom,
      })
      queryResult.push({
        fieldName: 'custom.siReleaseDate',
        command: 'Lte',
        value: this.query.siReleaseDateTo,
      })
      queryResult.push({
        fieldName: 'custom.sentEmail',
        command: 'Eq',
        value: this.query.sentEmail,
      })
      queryResult.push({
        fieldName: 'orderPlacer',
        command: this.query.orderPlacer ? 'NotNull' : 'IsNull',
        value: this.query.orderPlacer,
      })
      queryResult.push({
        fieldName: 'custom.agentWaybillReturnedDate',
        command: this.query.agentWaybillReturnedDate ? 'NotNull' : 'IsNull',
        value: this.query.agentWaybillReturnedDate,
      })
      queryResult.push({
        fieldName: 'custom.shipmentConfirmDate',
        command: this.query.shipmentConfirmDate ? 'NotNull' : 'IsNull',
        value: this.query.shipmentConfirmDate,
      })
      queryResult.push({
        fieldName: 'custom.containerPackingListDate',
        command: this.query.containerPackingListDate ? 'NotNull' : 'IsNull',
        value: this.query.containerPackingListDate,
      })
      queryResult.push({
        fieldName: 'custom.customInvDate',
        command: this.query.customInvDate ? 'NotNull' : 'IsNull',
        value: this.query.customInvDate,
      })
      queryResult.push({
        fieldName: 'custom.dateOfShipment',
        command: this.query.dateOfShipment ? 'NotNull' : 'IsNull',
        value: this.query.dateOfShipment,
      })
      queryResult = [...queryResult, ...this.getUserQuery()]
      return queryResult
    },
    getUserQuery() {
      var queryResult = []
      var autohorities = this.$getEmployee().tdocDataAuthorities
      var roles = this.$getEmployee().roles
      queryResult.push({
        fieldName: 'custom.consigneeFromTdoc.contactPartnerId',
        command: 'In',
        value:
          roles.indexOf('ROLE_WEB_VIEWER') === -1
            ? null
            : autohorities
            ? autohorities
                .split(',')
                .map((a) => a.split(':')[0])
                .join(',')
            : ' , ',
      })
      return queryResult
    },
    load() {
      var employeeId = this.$getEmployee().id
      var queryResult = this.getQueryResult()
      this.$http
        .post(`/tdoc/bls/list`, {
          units: queryResult,
          ...this.$pageable(),
          ...this.query,
          employeeId: employeeId,
        })
        .then((res) => {
          this.pagination.page = res.data.page + 1
          this.pagination.rowsPerPage = res.data.rowsPerPage
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.$storeParams()
      this.pagination.page = 0
      this.load()
    },
    openSortSettings() {
      var employeeId = this.$getEmployee().id

      this.$refs.csvFields
        .popupByEmployeeId('ソート設定', this.headersWithoutDetail, employeeId)
        .then((fields) => {
          console.log(fields)
          this.$http
            .put(
              `/tdoc/bls/${employeeId}/sort`,
              fields.map((f) => {
                return {
                  fieldName: f.value,
                  seq: f.seq,
                  sortMethod: f.sort,
                  employeeId: employeeId,
                }
              })
            )
            .then(() => {
              this.load()
              this.$message('', 'ソート設定しました。')
            })
        })
    },
    goToNew() {
      this.$router.push('/t-doc/New')
    },
    goToEdit() {
      this.$router.push({
        name: 'TdocEdit',
        query: {
          id: this.selected[0].id,
          title: 'B/L 編集',
        },
      })
    },
    goToDetail(item) {
      this.$router.push({
        name: 'TdocEdit',
        query: {
          id: item.id,
          disabled: true,
        },
      })
    },
    removeBL() {
      if (this.selected.filter((p) => p.sentEmail).length > 0) {
        this.$message('', '送信済みなので、当該BL情報が削除できません。')
        return
      }
      this.$confirm({
        content: '本当に削除しますか?',
        action: 'はい',
        rejectAction: 'いいえ',
      })
        .then(() => {
          this.$http
            .put('/tdoc/bls/delete', this.selected.map((s) => s.id))
            .then(() => {
              this.load()
              this.$message('', 'BL削除しました。')
            })
            .catch((err) => {
              this.$message('', 'BL削除失敗しました。')
            })
        })
        .catch(() => {})
    },
    sendMail() {
      this.$router.push({
        name: 'TdocSendMail',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    mailHistory() {
      this.$router.push({
        name: 'TdocMailHistory',
        query: {
          blNo: this.selected[0].blNo,
        },
      })
    },
    addInvoicePdf() {
      this.$refs.addInvoicePdfDialog
        .popup(this.selected[0].id)
        .then((invoice) => {
          this.bl.invoices.push(invoice)
        })
    },
    addAttachment(attachment) {
      this.$http
        .put(`/tdoc/bls/attachments/${this.selected[0].id}`, attachment)
        .then(() => {
          this.$message('', 'BLファイルアップロードしました。')
        })
        .catch((err) => {
          this.$message('', 'BLファイルアップロード失敗しました。')
        })
    },
    getString(value, showSplit) {
      if (!value) return ''
      if (showSplit) {
        return showSplit + value
      }
      return value
    },
    getShippingMode(code) {
      var shippingMode = this.$store.state.shippingModes.find(
        (m) => code === m.value
      )
      if (shippingMode) {
        return shippingMode.text
      }
      return code
    },
    downloadFailedExcel() {
      this.$refs.downloadDialog.popup().then((res) => {
        this.$download(`/tdoc/bls/download-failed`, {
          yyyyMM: res,
        })
      })
    },
    downloadExcel() {
      this.$refs.downloadDialog.popup().then((res) => {
        var queryResult = this.getUserQuery().filter((p) => !!p.value)
        this.$download(`/tdoc/bls/download`, {
          yyyyMM: res,
          customs: JSON.stringify(queryResult)
            .replace('[', '')
            .replaceAll(']', ''),
          // ...this.query,
          //...this.$pageable(),
          size: 99999,
          page: 0,
        })
      })
    },
    printPdf() {
      return this.$download(`/tdoc/bls/${this.selected[0].id}/pdf`)
    },
    openAwbPdfDialog() {
      this.$http.get(`tdoc/bls/${this.selected[0].id}`).then((res) => {
        this.chosenBl = res.data
        this.show = true
      })
    },
    getBuyerInvNo(data) {
      if (!data) {
        return ''
      }
      return data.join(' / ')
    },
    getSiNos(inv) {
      if (!inv) {
        return ''
      }
      return inv.map((i) => i.siNo).join(' / ')
    },
    getInvNos(inv) {
      if (!inv) {
        return ''
      }
      return inv.map((i) => i.invNo).join(' / ')
    },
    upload(data) {
      console.log(data)
      var result = data
        .filter((d) => d[0] != 'KOSNYYMD')
        .map((d) => {
          return {
            kosnyymd: d[0],
            kosnhhms: d[1],
            kosntask: String(d[2]).trim(),
            kosntant: String(d[3]).trim(),
            blno: String(d[4]).trim(),
            bldtyymd: d[5],
            sendflag: d[6],
            mailadrs: String(d[7]).trim(),
            name: String(d[8]).trim(),
            senddate: d[9],
            sendtime: d[10],
            subjct: String(d[11]).trim(),
            biko: String(d[12]).trim(),
          }
        })
      this.$http
        .post(`/tdoc/excels/mail-history`, result)
        .then(() => {
          this.$message('', 'upload success')
        })
        .catch((err) => {
          this.$message('', 'upload failed')
        })
      console.log(result)
    },
    isOperator() {
      return this.$getEmployee().roles.indexOf('ROLE_SJL_SHIPPER') > -1
    },
  },
  computed: {
    headersWithoutDetail() {
      return this.headers.filter((h) => h.value !== 'detail')
    },
    newFileName() {
      if (this.selected.length > 0)
        return this.$generateAwbFileName(
          this.selected[0].blNo,
          this.selected[0].blDate,
          this.selected[0].attachments
        )
    },
  },
  mounted() {
    this.$loadParams()
    this.$setEmployee().then(() => {
      // this.load()
    })
  },
  watch: {
    pagination() {
      this.load()
    },
  },
}
</script>

<style scoped>
.bl-date-wrap {
  display: flex;
}

table.options {
  font-size: 12px;
  border: 1px solid #ccc;
  width: 100%;
}

table.options /deep/ tr {
  height: 20px !important;
}

table.options /deep/.v-input--selection-controls__input {
  margin: auto;
}

.options-label {
  font-size: 12px;
}
</style>
